import React from "react";
import styles from "./SocialMedia.module.scss";
import cn from "classnames";
import socialMedia from '../../data/socialMediaData.json';

interface SocialMediaProps {
    className?: string,
}

const SocialMedia: React.FC<SocialMediaProps> = ({className}) => {
    return (
        <div className={cn(className, styles.socialMedia)}>
            {socialMedia.map((social) =>
                <a key={social.id} href={social.link} className={styles.socialMediaItem} target="_blank">
                    <img src={social.image} alt="ELS Group социальные сети"/>
                </a>
            )}
        </div>
    )
}

export default SocialMedia;